import { FC, useCallback, useEffect, useState } from "react";
import { QRCodeSVG } from 'qrcode.react';
import { Paper } from "@material-ui/core";
import { Formater, TypeRecords } from "src/framework/commons";
import { FullWidthButton } from "src/framework/components/buttons";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import "./styles.scss"
import { faCopy, faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { IPixResponseType } from "src/types";
import { Skeleton } from "@material-ui/lab";


interface QRCodeProperties {
    pix: IPixResponseType,
    onDisabled: (disabled: boolean) => void
}

const QRCode: FC<QRCodeProperties> = ({
    pix,
    onDisabled
}) => {
    const [times, setTime] = useState<string>()
    const [disabled, setDisabled] = useState<boolean>(false)

    const countDown = () => {
        const expire: moment.Moment = moment(pix.data_expiracao);
        const now: moment.Moment = moment();

        const seconds = expire.diff(now, "seconds")
        if (seconds <= 0) {
            setDisabled(true)
            return;
        }
        const countTime = moment(`2022-01-01 00:00:00`).add(seconds, "seconds")
        let counter = seconds;
        setInterval(() => {
            if (counter === 0) {
                setDisabled(true);
                return;
            }
            setTime(countTime.subtract(1, "second").format("00:mm:ss"))
            counter--;
        }, 1000)
    }

    useEffect(() => {
        if (disabled) {
            onDisabled(true)
        }
    }, [disabled])
    
    useEffect(() => {
        countDown();
    }, [pix])

    useEffect(() => {
    }, [times])

    const buildImageSrc = useCallback((url: string | undefined) => {
        if (!url) return ''
        const isUrl = url.includes("http") || url.includes("https");
        if (isUrl) return url;
        return `data:image/png;base64,${url}`
    }, [])

    return <>
        <div className="QRCode">
            <Paper className="paper" elevation={0}>
                {disabled && (<div className="expire-layer">
                    <FontAwesomeIcon className="expire-icon" icon={faWarning} size="4x" />
                    <p>Tempo para pagamento do QRcode expirado</p>
                </div>)}
                <div className="row">
                    {/* <div className="X12">
                        <div className="title">Continue com o pagamento do pix</div>
                    </div> */}
                    <div className="X12 qrcode-container">
                        {!disabled && <img width={"300px"} src={buildImageSrc(pix.url_qrcode)} />}
                        {disabled &&<Skeleton 
                            variant="rect"
                            width={250}
                            height={250}
                        />}
                    </div>
                    <div className="X12">
                        <div className="info">
                            <div className="item">
                                <div className="description">Valor:</div>
                                <div className="value">{Formater.toString(pix.valor_original, TypeRecords.CURRENCY)}</div>
                            </div>
                            {/* <div className="item">
                                <div className="description">Para:</div>
                                <div className="value">{pix.nome}</div>
                            </div> */}
                            <div className="item">
                                <div className="description">Expira em:</div>
                                <div className="value">{disabled ? "" : times}</div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </Paper>
        </div>
    </>
}

export { QRCode }